import { render, staticRenderFns } from "./ColorContrastChecker.vue?vue&type=template&id=5e1cd000"
import script from "./ColorContrastChecker.vue?vue&type=script&lang=js"
export * from "./ColorContrastChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports